export class Lookup {
    id: string;
    name: string;
}
